var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('header',[_c('div',[_c('doe-fieldset-heading',[_vm._v(_vm._s(_vm.label))]),(_vm.description)?_c('paragraph',{staticClass:"mt-2",attrs:{"description":_vm.description}}):_vm._e()],1),(_vm.editable)?_c('div',[_c('router-link',{attrs:{"to":{
          name: _vm.routeName,
          params: { statementUuid: _vm.$route.params.statementUuid },
          query: { edit: true }
        }}},[_vm._v("\n        Edit\n      ")])],1):_vm._e()]):_vm._e(),_c('div',{staticClass:"border-solid border-0 border-t border-b border-gray-600 max-w-4xl pt-5 pb-1"},_vm._l((_vm.filteredSchema),function(field,index){return _c('span',{key:index},[_c(field.fieldType,_vm._b({tag:"component",class:{
          'border-t border-gray-500 pt-4': _vm.hasTopBorder(
            index,
            field.fieldType
          )
        },attrs:{"value":_vm.value[field.name]}},'component',field,false))],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }